import { render, staticRenderFns } from "./order-submit-unsubscribe.vue?vue&type=template&id=be2b3eca&scoped=true"
import script from "./order-submit-unsubscribe.vue?vue&type=script&lang=ts"
export * from "./order-submit-unsubscribe.vue?vue&type=script&lang=ts"
import style0 from "./order-submit-unsubscribe.vue?vue&type=style&index=0&id=be2b3eca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be2b3eca",
  null
  
)

export default component.exports